import styled from 'styled-components';
import ShieldIcon from '../../../../Icons/ShieldIcon';
import Image from '../../common/Image/Image';
import {PrimaryLink} from '../../../CommonStyleUtils/dwebCommon.styles';

/*** go stay hover */

export const WrapperDivContainer = styled.section(
  props => `
  border-radius: ${props.theme.misc.borderRadius.base};
  background-color: ${props.theme.colors.goBrandBlue.base};
  width: 100%;
  position:relative;
  top:0rem;
  overflow:hidden;
  display: flex;
  flex-direction: column;
  justify-content:end;
`,
);

export const SliderGoStaysCircle = styled.div(
  props => `
  width: 60rem;
  height: 42rem;
  border-radius: ${props.theme.misc.borderRadius.round};
  background-color: ${props.theme.colors.goBrandBlue.dark};
  display: flex;
  position: absolute;
  top: -35rem;
  right: -17rem;
  z-index:-1;
  `,
);

export const GoStayHoverHeader = styled.div(
  props => `
  display:flex;
  align-items:center;
  background-color:${props.theme.colors.goBrandBlue.dark};
  padding:${props.theme.spacing.small} ${props.theme.spacing.custom(16)};
`,
);

export const GoStayImageWrap = styled(Image)`
  width: 2.8rem;
  height: 2.8rem;
`;

export const GoStayTitleWrap = styled.p(
  props => `
  font-size: ${props.theme.font.custom(16)};
  color: ${props.theme.colors.goWhite.base};
  font-family: ${props.theme.font.fontFamily};
  font-weight:bold;
  padding-left: ${props.theme.spacing.base};
`,
);

export const GoStayHoverContentOuter = styled.div(
  props => `
  min-height:17rem;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  padding: ${props.theme.spacing.base} ${props.theme.spacing.custom(16)};
`,
);

export const GoStayHoverContent = styled.ul(
  props => `
  list-style-type: none;
`,
);

export const GoStayHoverList = styled.li(
  props => `
  font-size: ${props.theme.font.custom(14)};
  color: ${props.theme.colors.goWhite.base};
  margin:${props.theme.spacing.small} 0;
  width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`,
);

export const ShieldIconWrap = styled(ShieldIcon)(
  props => `
  width:1.5rem;
  height:1.5rem;
  color:${props.theme.colors.goBrandBlue.base};
  margin-right:${props.theme.spacing.large};
  cursor:pointer;

`,
);

export const ShowPropertiesBtn = styled(PrimaryLink)(
  props => `
  width:fit-content;
  font-size: ${props.theme.font.custom(14)};
  font-weight:bold;
  color: ${props.theme.colors.goWhite.base};
  background-color: ${props.theme.colors.goBrandBlue.base};
  border:1px solid ${props.theme.colors.goWhite.base}
  border-radius: ${props.theme.misc.borderRadius.custom(16)}
  padding: ${props.theme.spacing.small} ${props.theme.spacing.large};
`,
);
